import { forwardRef, type InputHTMLAttributes, type KeyboardEvent } from 'react'
import { cn } from '@/components/ui/cn'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean
  onEnter?: () => void
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, hasError = false, onEnter, onKeyDown, ...props },
  ref
) {
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    onKeyDown?.(event)
    if (!event.defaultPrevented && event.key === 'Enter' && onEnter) {
      event.preventDefault()
      onEnter()
    }
  }

  return (
    <input
      ref={ref}
      className={cn(
        // text-base on small viewports: iOS Safari zooms focused inputs under 16px
        'flex h-10 w-full rounded-md border bg-background px-3 py-2 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-base file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm md:file:text-sm',
        hasError && 'border-destructive focus-visible:ring-destructive',
        className
      )}
      onKeyDown={handleKeyDown}
      {...props}
    />
  )
})
